﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcChartHierarchical from '@mescius/wijmo.chart.hierarchical';
var WjSunburstBehavior = /** @class */ (function (_super) {
    __extends(WjSunburstBehavior, _super);
    function WjSunburstBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjSunburstBehavior.prototype._updateControl = function (property, newValue) {
        switch (property) {
            case 'tooltipContent':
                this.control.tooltip.content = newValue;
                break;
            case 'labelContent':
                this.control.dataLabel.content = newValue;
                break;
            default:
                _super.prototype._updateControl.call(this, property, newValue);
        }
    };
    WjSunburstBehavior.tag = 'wj-sunburst';
    WjSunburstBehavior.props = [
        'isDisabled',
        'tabOrder',
        'binding',
        'footer',
        'header',
        'selectionMode',
        'palette',
        'plotMargin',
        'footerStyle',
        'headerStyle',
        'tooltipContent',
        'itemsSource',
        'bindingName',
        'innerRadius',
        'isAnimated',
        'offset',
        'options',
        'reversed',
        'startAngle',
        'selectedIndex',
        'selectedItemPosition',
        'selectedItemOffset',
        'itemFormatter',
        'labelContent',
        'childItemsPath'
    ];
    WjSunburstBehavior.events = [
        'initialized',
        'gotFocus',
        'lostFocus',
        'refreshing',
        'refreshed',
        'invalidInput',
        'rendering',
        'rendered',
        'selectionChanged',
        'itemsSourceChanging',
        'itemsSourceChanged'
    ];
    WjSunburstBehavior.classCtor = function () { return wjcChartHierarchical.Sunburst; };
    return WjSunburstBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.hierarchical.Sunburst} control.
 *
 * The <b>wj-sunburst</b> component may contain
 * a {@link wijmo.vue2.chart.WjFlexChartLegend} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.hierarchical.Sunburst} control it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjSunburst = WjSunburstBehavior.register();
function registerV3WjSunburst(app) {
    app.component(WjSunburstBehavior.tag, WjSunburst);
}
var WjTreeMapBehavior = /** @class */ (function (_super) {
    __extends(WjTreeMapBehavior, _super);
    function WjTreeMapBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjTreeMapBehavior.prototype._updateControl = function (property, newValue) {
        switch (property) {
            case 'tooltipContent':
                this.control.tooltip.content = newValue;
                break;
            case 'labelContent':
                this.control.dataLabel.content = newValue;
                break;
            default:
                _super.prototype._updateControl.call(this, property, newValue);
        }
    };
    WjTreeMapBehavior.tag = 'wj-tree-map';
    WjTreeMapBehavior.props = [
        'isDisabled',
        'tabOrder',
        'binding',
        'footer',
        'header',
        'selectionMode',
        'options',
        'palette',
        'plotMargin',
        'footerStyle',
        'headerStyle',
        'tooltipContent',
        'itemsSource',
        'bindingName',
        'maxDepth',
        'type',
        'labelContent',
        'childItemsPath'
    ];
    WjTreeMapBehavior.events = [
        'initialized',
        'gotFocus',
        'lostFocus',
        'refreshing',
        'refreshed',
        'invalidInput',
        'rendering',
        'rendered',
        'selectionChanged',
        'itemsSourceChanging',
        'itemsSourceChanged'
    ];
    WjTreeMapBehavior.classCtor = function () { return wjcChartHierarchical.TreeMap; };
    return WjTreeMapBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.hierarchical.TreeMap} control.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.hierarchical.TreeMap} control it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjTreeMap = WjTreeMapBehavior.register();
function registerV3WjTreeMap(app) {
    app.component(WjTreeMapBehavior.tag, WjTreeMap);
}
export function registerChartHierarchical(app) {
    if (VueApi.isV3Plus) {
        registerV3WjSunburst(app);
        registerV3WjTreeMap(app);
    }
}
